/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const getters = {
    getCapInfo: (state) => {
        return state.capsInfo
    },
    getGeoIntegrations: (state) => (filterParams) => {
        const temp = []
        state.capsList.filter((value, index) => {
            temp.push({...value})
            temp[temp.length - 1].advertiser_integrations = []
            temp[temp.length - 1].advertiser_integrations = value.advertiser_integrations.filter((val) => {
                if (val.geo.name === filterParams.geo && val.traffic_model.name === filterParams.model) {
                    return true
                }
            })
            if (!temp[temp.length - 1].advertiser_integrations.length) temp.splice(temp.length - 1, 1)
        })

        temp.sort((a, b) => {
            if (a.name < b.name) return -1
        })

        return temp
    }
}

export default getters
